import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text, SelectField } from "ui-components/Form";
import RangeInputGroup from "./ColourRange";

const options = {
  type: ["Carton", "Flyer"],
};

function KPIUserRangeInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit KPI User Range" : "KPI User Range Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              let renderField;
              switch (fieldProps.type) {
                case "text":
                  if (fieldProps.name !== "range")
                    renderField = <Text field={fieldProps} />;
                  else 
                    renderField = (
                    <RangeInputGroup {...fieldProps} />)
                  break;
              }

              return (
                <Grid item xs={12} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default KPIUserRangeInfo;
